var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 231,
    viewBox: "0 0 231 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M218.25 96.4848C218.73 104.855 219.209 113.633 219.726 122.668C220.85 131.49 221.996 140.587 223.071 149.786C224.658 158.748 226.036 167.779 227.082 176.682C228.403 185.217 229.142 193.462 229.163 201.161C228.697 211.405 222.144 225.641 215.578 228.82C210.459 229.572 204.06 228.975 196.43 227.119C188.652 224.852 179.807 221.78 170.073 218.23C160.512 215.154 150.714 212.356 140.899 210.083C131.474 208.903 122.058 208.41 112.743 208.556C103.813 209.784 94.9079 211.423 86.0803 213.228C77.5372 215.699 68.9938 217.948 60.5676 219.708C52.3873 221.655 44.3868 222.767 36.7467 222.876C26.1632 222.172 9.51894 213.871 4.32634 206.032C2.06053 199.974 1.06891 192.568 1.41756 183.824C2.45528 174.824 4.60256 165.034 7.58843 154.706C10.8288 144.304 14.6016 133.496 18.7066 122.498C22.6786 111.6 26.7813 100.627 30.9234 89.7867C34.7756 79.1827 38.6471 68.8177 42.5637 58.9161C46.2465 49.4264 50.112 40.5312 54.2522 32.466C58.349 24.985 62.924 18.4765 68.059 13.1182C73.3542 8.48666 79.354 5.05987 86.1042 2.9556C93.0794 1.49107 100.821 1.23188 109.287 2.13285C117.876 3.31857 126.644 5.31003 135.386 7.86659C144.023 10.2175 152.491 12.8933 160.588 15.7879C168.388 18.2064 175.702 20.8022 182.407 23.5741C191.526 27.192 205.502 35.7954 210.257 41.3136C213.814 47.2995 217.392 63.2287 217.83 73.2928C218.173 80.1754 218.283 87.9136 218.25 96.4848Z",
    stroke: "#5A42ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "6 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector17);
export default __webpack_public_path__ + "static/media/Vector-17.ed783214e59d15df571705b8e524f89e.svg";
export { ForwardRef as ReactComponent };